import { Icon } from '@material-ui/core';
import React from 'react';
import '../../assets/css/font-awesome.css';

/**
 * FontAwesome Icon component
 */
export const FontAwesomeIcon = props => {
  const {
    color,
    fontSize,
    classes,
    iconName,
    style,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement(Icon, {
    color: color || 'primary',
    fontSize: fontSize || 'default',
    classes: classes,
    className: `fa fa-${iconName}`,
    style: style,
    onClick: onClick
  }, props.children);
};
//# sourceMappingURL=Icon.js.map